// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__1iU-1","footerhead":"style_footerhead__rQ-S2","itemUl":"style_itemUl__bZjcl","footerBottom":"style_footerBottom__TA8Ou","icon":"style_icon__RKGxL"};